export default {
  install(Vue, {
    containerId, containerIds, originalLocation, partnerGA,
  }) {
    const allContainerIds = (containerId ? [containerId] : []).concat(containerIds || []);
    if (!allContainerIds.length) { throw new Error('ArgumentError: At least one GTM containerId is required.'); }

    window.analyticsDataLayer = [];

    allContainerIds.forEach((containerId) => {
      (function (w, d, s, l, i) {
        w[l] = w[l] || []; w[l].push({
          'gtm.start':
            new Date().getTime(),
          event: 'gtm.js',
        }); const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s); const dl = l != 'dataLayer' ? `&l=${l}` : ''; j.async = true; j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`; f.parentNode.insertBefore(j, f);
      }(window, document, 'script', 'analyticsDataLayer', containerId));
    });

    if (originalLocation) {
      // The purpose of the originalLocation is to tell Google Tag Manager
      // what location to use for ALL virtual page views.
      // By default, GTM is using the current document.location and that is causing
      // the referral source of our user sessions to switch from Paid to Organic.
      // See: FP-103
      window.analyticsDataLayer.push({ originalLocation });
    }
    if (partnerGA) {
      window.analyticsDataLayer.push({ PartnerGA: partnerGA });
    }

    Vue.prototype.$googleTagManager = {
      pushPageView(path, title) {
        if (window.analyticsDataLayer) {
          window.analyticsDataLayer.push({
            event: 'VirtualPageview',
            originalLocation,
            VirtualPageTitle: title,
            VirtualPageURL: path,
          });
        }
      },
      pushEvent(eventName, eventObject) {
        if (window.analyticsDataLayer) {
          window.analyticsDataLayer.push({
            event: eventName,
            originalLocation,
            ...eventObject,
          });
        }
      },
    };
  },
};
